import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, GET_AMZ_PRODUCT_URL, PAGE_SIZE } from '../../common/constants';
import { formatTo2Decimal, isEmpty, isEmptyArray} from '../../common/util.services';
import { exportFeeDataSku, getFeeData, getInvAttribute } from '../amazon.services';
import { Grid } from '@mui/material';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';

const AmazonFee = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [feeData, setFeeData] = useState(rows);
  const [product, setProduct] = useState(ALL);
  const [size, setSize] = useState(ALL);
  const [pack, setPack] = useState(ALL);
  const [feeDiff, setFeeDiff] = useState(null);
  const [sizeList, setSizeList] = useState();
  const [packList, setPackList] = useState();
  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 200,
      cellClassName: (params) => { return getClassName(params) }
    },
    { field: 'color', headerName: 'Color', filterable: false, sortable: false, editable: false, width: 200,
      cellClassName: (params) => { return getClassName(params) }
    },
    { field: 'size', headerName: 'Size', filterable: false, sortable: false, editable: false, width: 150,
      cellClassName: (params) => { return getClassName(params) }
    },
    { field: 'unitCount', headerName: 'Pack', filterable: false, sortable: false, editable: false, width: 120,
      cellClassName: (params) => { return getClassName(params) }
    },
    { field: 'sku', headerName: 'SKU', filterable: false, sortable: false, editable: false, width: 180 ,
      cellClassName: (params) => { return getClassName(params) }
    },
    { field: 'price', headerName: 'Price', filterable: false, sortable: false, editable: false, width: 120,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : formatTo2Decimal(value),
      cellClassName: (params) => { return getClassName(params) }
    },
    { field: 'fulfillmentFee', headerName: 'Fee', filterable: false, sortable: false, editable: false, width: 120,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : formatTo2Decimal(value),
      cellClassName: (params) => { return getClassName(params) }
    },
    { field: 'fulfillmentFeePct', headerName: 'Fee/Price', filterable: false, sortable: false, editable: false, width: 120,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : formatTo2Decimal(value) + '%',
      cellClassName: (params) => { return getClassName(params) }
    },
    { field: 'feeDiff', headerName: 'High - Low', filterable: false, sortable: false, editable: false, width: 120,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : formatTo2Decimal(value) + '%',
      cellClassName: (params) => { return getClassName(params) }
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getInventoryData(page);
  }, [product, size, pack, feeDiff, page, pageSize]);

  function getClassName(value: any) {
    if(0 === value.row.rowId) {
      if('product' === value.field) {
        return 'Row1Prd';
      } else if('feeDiff' === value.field) {
        return isEmpty(value.row.feeDiff) ? 'Row2Prd' : value.row.feeDiff > 0 ? 'Row2Prd' : 'Row1Prd';
      } else if('fulfillmentFee' === value.field) {
        return 0 === value.row.fulfillmentFee ? 'Row2Prd' : 'Row1';
      } else {
        return 'Row1';
      }
    } else {
      if('product' === value.field) {
        return 'Row2Prd';
      } else if('feeDiff' === value.field) {
        return isEmpty(value.row.feeDiff) ? 'Row2Prd' : value.row.feeDiff > 0 ? 'Row2Prd' : 'Row1Prd';
      } else if('fulfillmentFee' === value.field) {
        return 0 === value.row.fulfillmentFee ? 'Row2Prd' : 'Row2';
      } else {
        return 'Row2';
      }
    }
  }

  function getInventoryData(page: any) {
    if (isEmptyArray(rows)) {
      setLoading(true);
      let searchData = {product: product, size: size, pack: pack, feeDiff: feeDiff};
      getFeeData(searchData, page, pageSize, appContext,
        (response: any) => {
          setFeeData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }
  
  const search = (data: any) => {
    getInventoryData(0);
  }

  const updateAttributeList = (invProduct: any) => {
    setLoading(true);
    getInvAttribute(invProduct, appContext,
      (response: any) => {
        setSizeList(response.data[1]);
        setPackList(response.data[2]);
        appContext.setShowLoader(false);
        appContext.setSuccessMessage(response.message)
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const exportData = () => {
    exportFeeDataSku(appContext,
      (response: any) => {
        saveExcel(response.data);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        setLoading(false);
      });
  }

  const saveExcel = (feeData: any) => {
    let header = ["Product", "Color", "Size", "Pack", "SKU", "Price", "Fee", "Fee/Price", "High - Low", "Id"];
    const excelSheet = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(excelSheet, [header]);
    XLSX.utils.sheet_add_json(excelSheet, feeData, { origin: 'A2', skipHeader: true });
    const excelBook = { Sheets: { 'Fee': excelSheet }, SheetNames: ['Fee'] };
    const excelBuffer = XLSX.write(excelBook, { bookType: 'xlsx', type: 'array', cellStyles:true });
    const excelData = new Blob([excelBuffer], { type: 'xlsx' });
    FileSaver.saveAs(excelData, "Amazon_Fee.xlsx");
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} showExportBtn={true} export={exportData}>
      <Grid container spacing={1}>
        <Grid xs={3}>
          <IDropdown name='product' label='Product' url={GET_AMZ_PRODUCT_URL} allItemRequired={true}
            onChangeEvent={(e: any) => {setProduct(e.target.value); setSize(ALL); 
                                        setPack(ALL); updateAttributeList(e.target.value); setPage(0);}} />
        </Grid>
        <Grid xs={3}>
          <IDropdown name='size' label='Size' itemList={sizeList} allItemRequired={true}
            onChangeEvent={(e: any) => {setSize(e.target.value); setPage(0);}}/>
        </Grid>
        <Grid xs={3}>
          <IDropdown name='pack' label='Pack' itemList={packList} allItemRequired={true}
            onChangeEvent={(e: any) => {setPack(e.target.value); setPage(0);}}/>
        </Grid>
        <Grid xs={3}>
          <INumberField name='feeDiff' label='Fee Diff >='
            onActionEvent={(e: any) => {setFeeDiff(e.target.value); setPage(0);}}/>
        </Grid>
      </Grid>
    </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={feeData} columns={columns} loading={loading} 
        showExtBtn={false} extBtnAction={exportData} extBtnText={'Export'}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={false} showApproveAction={false} showDeleteAction={false} showAddBtn={false} 
        getRowId={(row: any) => row.sku} maxHeight={480}/>
    </>
  }

  return <TitlePanel title='Amazon Fee' panelBody={getMainPanel()} />
}

export default AmazonFee;

